/* eslint-disable max-len */
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';
import { AppState } from 'src/app/store/app.reducer';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { Observable, Subscription } from 'rxjs';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { StandardDynamicComponent, StandardNewValidator, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { MtmaRule, MtmaTimeslice } from 'src/app/model/mtma-rules-access';

@Component({
	selector: 'app-mtma-rule-dialog',
	templateUrl: './mtma-rule-dialog.component.html',
})

export class MtmaRuleDialogComponent implements OnInit, OnDestroy {
	rule: MtmaRule;
	editMode = false;

	ruleAddForm: FormGroup;

	editedSub: Subscription;
	addedSub: Subscription;
	deviceInfoSub: Subscription;
	mtmaRuleModifySub: Subscription;

	listTimeslices: MtmaTimeslice[];
	listTimeslicesSub: Subscription;

	timesliceCtrl = new FormControl();
	filteredTimeslices: Observable<MtmaTimeslice[]>;

	// design
	screenWidth: number;

	constructor(
		private fb: FormBuilder,
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig,
	) {
		this.rule = new MtmaRule();
		if (config.data !== undefined && config.data.rule !== undefined) {
			this.rule = config.data.rule;
			this.editMode = true;
		} else {
			this.rule.Timeslices = [];
		}
	}

	ngOnInit(): void {
		this.ruleAddForm = this.fb.group({
			'Name': new FormControl(this.rule.Name, [Validators.required, Validators.maxLength(48)]),
			'Timeslices': new FormControl(this.rule.Timeslices),
		});

		this.mtmaRuleModifySub = this.store.select('device', 'mtmaRuleModify')
			.pipe(filter(mtmaRuleModify => !!mtmaRuleModify))
			.subscribe(() => {
				this.resetClose();
			});

		this.store.dispatch(DeviceActions.getMtmaTimeSlicesAll());
		this.listTimeslicesSub = this.store.select('device', 'mtmaTimeslicesAll').subscribe(listTimeslices => {
			this.listTimeslices = listTimeslices;
		});

		this.filteredTimeslices = this.timesliceCtrl.valueChanges.pipe(
			map((timeslice: string | null) => timeslice ? this.filter(timeslice) : this.listTimeslices.slice())
		);

		this.onResize();
		StandardNewValidator.setFirstCompile(true);
	}

	ngOnDestroy(): void {
		this.editedSub?.unsubscribe();
		this.addedSub?.unsubscribe();
		this.deviceInfoSub?.unsubscribe();
	}

	resetClose(): void {
		this.store.dispatch(DeviceActions.resetRuleForm());
		this.closeDialog();
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.ruleAddForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.ruleAddForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	save(): void {
		this.rule.Name = this.f.Name.value;
		this.rule.Timeslices = this.f.Timeslices.value;
		if (this.rule.Id) {
			this.store.dispatch(DeviceActions.editMtmaRule({ rule: this.rule }));
		} else {
			this.store.dispatch(DeviceActions.addMtmaRule({ rule: this.rule }));
		}
	}

	filter(value: string): MtmaTimeslice[] {
		if (typeof value === 'string') {
			const filterValue = value.toLowerCase();
			return this.listTimeslices.filter(timeslice => timeslice.Name.toLowerCase().indexOf(filterValue) >= 0);
		}
		return this.listTimeslices;
	}

	remove(timeslice: MtmaTimeslice): void {
		const index = this.rule.Timeslices.indexOf(timeslice);

		if (index >= 0) {
			this.rule.Timeslices.splice(index, 1);
		}
	}

	get f(): any {
		return this.ruleAddForm.controls;
	}

	closeDialog(): void {
		this.ref.close();
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-23rem');
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	newShowErrors(type: MtmaRuleDialogComponent["f"], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: MtmaRuleDialogComponent["f"]): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	simpleInputTextLayout(classType: string): string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}

	dynamicDatepicker(): string {
		return StandardDynamicComponent.dynamicDatepicker(this.screenWidth);
	}

	customPaddingX(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}

}
